'use client'

import { useAnalytics } from "@/hooks/useAnalytics";
import { MetricsEvent } from "@/lib/analytics/metrics";
import { useEffectOnce } from "react-use";

const AnalyticsEvent = ({ event }: { event: MetricsEvent; }) => {
  const { track } = useAnalytics();
  
  useEffectOnce(() => {
    track(event)
  });
  
  return null;
};

export default AnalyticsEvent;